/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Cat_LegalInputs */

const cs_builder_cat_legal = /** @type {(inputs: Builder_Cat_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Právní`)
};

const en_builder_cat_legal = /** @type {(inputs: Builder_Cat_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal`)
};

/**
* | output |
* | --- |
* | "Legal" |
*
* @param {Builder_Cat_LegalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_cat_legal = /** @type {((inputs?: Builder_Cat_LegalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Cat_LegalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_cat_legal(inputs)
	return cs_builder_cat_legal(inputs)
});